import React, { Fragment } from "react";
import './Formulas.css';
import {animation} from "../stores/AnimationStore";

/*
    x &   ((7-y)<8)    &    ((7-y)>1) + Math.sin(t*s+x*x) + (x/4);

    x & (7-y)<8 & (7-y)>1 + sin(t*s+x*x) + (x/4)
    x & ((7-y)<8) & ((7-y)>1 + sin(t*s+x*x) + (x/4))

    x & ((7-y)<8) & ((7-y)>1)

    round(sin(t)*7.5 + 7.5)     : 0..15

    // 3*(x - round(sin(t)*7.5 + 7.5)    )+1


    // 3*(y - round((sin(t*s)*3.5 + 3.5)))+1
    // (3*(x - round((sin(t*s)*7.5 + 7.5)))+1) | (3*(y - round((sin(t*s)*3.5 + 3.5)))+1)
    // ((3*(x - round((sin(t*s)*7.5 + 7.5)))+1) === 1) || ((3*(y - round((sin(t*s)*3.5 + 3.5)))+1) === 1) ? 1 : 10


    ((3*(   x - round(sin(t)*7.5 + 7.5)  )+1) === 1) || ((3*(y - round((sin(t*1.5)*3.5 + 3.5)))+1) === 1) ? -1 :1



    (x === round(sin(t)*7.5 + 7.5)) || (y === round(sin(t)*3.5 + 3.5)) ? (r-0.5) : -1


(sin(t-hypot(x-7.5, y-3.5)) + sin(t/20)*2) / 2 @ s=4,c=0,1,9,0,0,0,6,5,0


    x==(round(sin(t)*-3+3)) | x==(round(sin(t)*3+12)) | y==(round(sin(t)*-2+2)) | y==(round(sin(t)*2+5)) ? 1 : -3
    x==0 | x==15 | y==(round(sin(t)*-3+3)) | y==(round(sin(t)*3+3)) ? 1 : -3

*/

const FORMULAS = {
    'scan-h' : 'x === round(sin(t)*7.5 + 7.5) ? 1 : -1 @ s=3 c=0,1',
    'scan-v' : 'y === round(sin(t)*3.5 + 3.5) ? 1 : -1 @ s=3 c=0,9',
    'v-wiper-color' : 'x === round(sin(t)*7.5 + 7.5) ? abs(sin(t)) : -1 @ s=3 c=0,1,2,3,4,5,6,9,10,11',
    'cross-wipe' : '(x === round(sin(t)*7.5 + 7.5)) || (y === round(sin(t)*3.5 + 3.5)) ? 1 : -1 @ c=0,1',
    'diag-wipe-128' : 'x - y - (sin(t)*11) - 4 @ s=2 c=11.1,9,1,9,11',
    'car-wipe-128' : 'x - sin(t)*y - (sin(t)*7.5) - 7.5 @ s=3 c=8,5,8',
    'spin-128' : 'sin(2*atan((y-3.5)/(x-7.5))+t) @ s=7 c=0,4,5',
    'spin-2-128' : 'sin(2*atan((y-3.5)/(x-7.5))+t) @ s=7 c=0,9,0',
    'spin-3-128' : 'sin(2*atan((y-3.5)/(x-7.5))+t) @ s=4 c=0,0,0,2,1,2,1,3,1,3,1,9,1,2,1,0,0,0',
    'waves-128' : '(sin(t-hypot(x-7.5, y-3.5)) + sin(t/20)*2) / 2 @ s=3 c=0,0,0,1,9,0,0,0,0,6,5,0',
    'rotate-ccw' : '(1-abs((x-7)*cos(t)+(y-4)*sin(t)) )*3-2 @s=8 c=1,11',
    'rotate-cw' : '1-abs((x-7)*sin(t)+(y-4)*cos(t)) @s=2 c=0,4,5,5',
    'rotate-move' : '1-abs((x-(7*sin(t)+7))*cos(t)+(y-4)*sin(t)) @s=2 c=0,1,8',
    'waves' : 'sin(x/2) - sin(x-t) + y - 4 @ c=0,1,8,9',
    'waves-blue' : 'sin(x/1.7) - sin((x-t)/1.1) + y/1.3 - 3 @ s=4 c=5,4,8',
    'waves-200' : 'sin(t-hypot(x-12, y-3.5)) @s=4 c=0,8,11,1',
    // 'disco-flash' : 'sin(t/3) * tan(t/7) @ c=1,2,3,4,5,6,8,9,10,11',
    // 'pacman' : 'hypot(x-=t%4*s,y-=4)<6&&x<y|y<-x',
    'borders-128' : 'x==0 | x==15 | y==0 | y==7 ? (2*r-1) : -3 @ c=1,2,3,4,5,6,8,9,10,11',
    'bargraph' : '-1 + 2*(x & (7-y)<8 & (7-y)>1+sin(t+x*x)+x/4) @s=10 c=0,1',
    'random' : 'r*2 - 1 @ c=0,1,0,2,0,3,0,4,0,5,0,6,0,8,0,9,0,10,0,11 r=5',
    'spin-200' : 'sin(2*atan((y-3.5)/(x-12))+t) @ s=7 c=0,4,5',
    'v-wiper-200' : 'x === round(sin(t)*12 + 12) ? 1 : -1 @ s=3 c=0,1',
    'diag-wipe-200' : 'x - y - (sin(t)*16) - 8.5 @ s=2 c=11,1,11',
    'car-wipe-200' : 'x - sin(t)*y - (sin(t)*12) - 12 @ s=3 c=8,5,8',
    'cross-wipe-200' : '(x === round(sin(t)*12 + 12)) || (y === round(sin(t)*3.5 + 3.5)) ? 1 : -1 @ c=0,1',
    'borders-200' : 'x==0 | x==24 | y==0 | y==7 ? 1 : -3'
};

export const Formulas = () => {

    const setInstructions = (formula: string) => {
        window.location.hash = encodeURIComponent(formula);
        animation.updateFormula(formula);
        // animation.newInstructions(formula);
    }

    return <div className="formulas mt20">
        {Object.entries(FORMULAS).map(([name, formula]) =>
            <Fragment  key={name}>
                <div>{name} :</div>
                <div className="formula" onClick={() => setInstructions(formula)}>{formula}</div>
            </Fragment>)}
    </div>;
}